/**
 * @author https://gitee.com/chu1204505056/vue-admin-better （不想保留author可删除）
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import router from '@/router'
import store from '@/store'
import VabProgress from 'nprogress'
import 'nprogress/nprogress.css'
import getPageTitle from '@/utils/pageTitle'
import {
	authentication,
	loginInterception,
	progressBar,
	recordRoute,
	routesWhiteList,
} from './setting.config'

VabProgress.configure({
	easing: 'ease',
	speed: 500,
	trickleSpeed: 200,
	showSpinner: false,
})
router.beforeResolve(async (to, from, next) => {
	if (progressBar) VabProgress.start()
	let hasToken = store.getters['user/accessToken'] 
	next()
	document.title = getPageTitle(to.meta.title)
})
router.afterEach(() => {
	if (progressBar) VabProgress.done()
})



// WEBPACK FOOTER //
// ./src/config/permission.js